import { SystemEntity } from '@erp/shared-types';
import { Badge } from '@/components/ui/badge';
import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
} from '@/components/ui/hover-card';
import { cn } from '@/lib/utils';
import { UserIcon } from '@phosphor-icons/react';
import { SystemEntityPreview } from '../preview-ui';
import useCustomer from '@/api/accounts-receivable/customers/useCustomer';

interface CustomerInlineProps {
  entityType: SystemEntity;
  entityId: string;
  className?: string;
}

export function CustomerInline({ entityId, className }: CustomerInlineProps) {
  const { data, isLoading } = useCustomer(entityId);

  const displayName = isLoading
    ? 'Loading...'
    : (data?.customer?.name ?? 'Customer');

  return (
    <HoverCard openDelay={200} closeDelay={100}>
      <HoverCardTrigger asChild>
        <div className="inline-block max-w-full">
          <Badge
            variant="outline"
            className={cn('gap-1.5 cursor-pointer max-w-full', className)}
          >
            <UserIcon className="size-3 shrink-0" />
            <span className="truncate">{displayName}</span>
          </Badge>
        </div>
      </HoverCardTrigger>
      <HoverCardContent className="w-auto p-0" align="start">
        <SystemEntityPreview
          entityType={SystemEntity.AR_CUSTOMER}
          entityId={entityId}
        />
      </HoverCardContent>
    </HoverCard>
  );
}
